import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tokens } from '../styles/tokens';
import { STRINGS } from '../data/strings';
import type { RecapDemarche } from '../types';
import './sarah-inscription';

@customElement('sarah-recap-demarches')
export class SarahRecapDemarches extends LitElement {
  static styles = [
    tokens,
    css`
      :host {
        display: block;
        font-family: var(--sarah-font-body);
        color: var(--sarah-text);
      }

      .recap-demarches { counter-reset: section; }

      .demarches-liste {
        margin: auto;
        width: 95%;
        max-width: 800px;
      }
      .demarches-liste p {
        border-top: 2px dashed;
        border-color: var(--sarah-bleu) !important;
        margin: 0;
        padding: 30px 45px;
        counter-increment: section;
        position: relative;
      }
      .demarches-liste p:before { transition: all .3s; }
      .demarches-liste p:nth-child(2n):before,
      .demarches-liste p:nth-child(odd):before {
        content: counter(section);
        font-weight: 700;
        position: absolute;
        border-radius: 50%;
        padding: 10px;
        height: 44px;
        width: 44px;
        text-align: center;
        color: #fff;
        font-size: 100%;
        line-height: normal;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        background-color: var(--sarah-rose);
        border: 8px solid #ffffffbd;
        transition: all .3s;
      }
      .demarches-liste p:nth-child(2n):before  { right: 100%; margin-right: -22px; }
      .demarches-liste p:nth-child(odd):before { left:  100%; margin-left:  -22px; }
      .demarches-liste p:nth-child(2n) {
        border-left: 2px dashed;
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
        margin-right: 25px;
        padding-right: 0;
        text-align: left;
      }
      .demarches-liste p:nth-child(odd) {
        border-right: 2px dashed;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        margin-left: 25px;
        padding-left: 0;
        text-align: right;
      }
      .demarches-liste p:first-child {
        border-top: 0;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
      }
      .demarches-liste p:last-child {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        padding-bottom: 50px;
      }
      .demarches-liste .title {
        font-weight: 700;
        font-size: 22px;
        display: block;
      }
      @media (max-width: 719px) {
        .demarches-liste .title { font-size: 20px; line-height: 1.125; }
      }
      .demarches-liste .title .uptitle { color: var(--sarah-rose); }
      .demarches-liste .content { display: block; font-size: 16px; }
      @media (max-width: 719px) { .demarches-liste .content { margin-top: 5px; } }

      .demarches-liste.demarches-hidden p:not(:first-child) {
        filter: blur(4px);
      }
    `,
  ];

  @property({ type: Array }) demarches: RecapDemarche[] = [];

  /**
   * Reproduit le comportement original : on n'affiche que la 1ère démarche
   * réelle + un stub flouté. Le reste est révélé après login via le bus
   * d'events parent (qui passera connected=true sur les inscriptions).
   */
  private buildList(): RecapDemarche[] {
    const list: RecapDemarche[] = [];
    if (this.demarches[0]) list.push(this.demarches[0]);
    list.push({
      demarche: STRINGS.demarcheStub,
      description: STRINGS.demarcheStubDesc,
    });
    return list;
  }

  render() {
    const list = this.buildList();
    return html`
      <div class="recap-demarches">
        <div class="demarches-liste demarches-hidden">
          ${list.map(
            (d) => html`
              <p>
                <span class="title">
                  <span class="uptitle">${d.demarche}</span>
                </span>
                <span class="content">${d.description || ''}</span>
              </p>
            `,
          )}
        </div>
        <sarah-inscription mode="recap"></sarah-inscription>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sarah-recap-demarches': SarahRecapDemarches;
  }
}
